/**
 * sl-9qm.4.2: Register Container + Content Components
 *
 * Called during StreamLain module initialization to register
 * all container and content components in the ComponentRegistry.
 */
import type { ComponentRegistry } from '../../services/component-registry';
import { Grid2Component } from './containers/grid-2';
import { Grid3Component } from './containers/grid-3';
import { SectionComponent } from './containers/section';
import { ArticleListComponent } from './content/article-list';
import { CardGridComponent } from './content/card-grid';
import { CustomHtmlBlockComponent } from './content/custom-html-block';
import { HeroBannerComponent } from './content/hero-banner';
import { MarkdownRendererComponent } from './content/markdown-renderer';
import { RelatedEntriesComponent } from './content/related-entries';
import { SingleArticleComponent } from './content/single-article';
import { TableViewComponent } from './content/table-view';
import { TagDisplayComponent } from './content/tag-display';

export function registerContainerAndContentComponents(
  registry: ComponentRegistry
): void {
  // Container components (sl-pbux.3.1)
  registry.register(SectionComponent);
  registry.register(Grid2Component);
  registry.register(Grid3Component);

  // Content components
  registry.register(CardGridComponent);
  registry.register(ArticleListComponent);
  registry.register(TableViewComponent);
  registry.register(SingleArticleComponent);
  registry.register(MarkdownRendererComponent);
  registry.register(CustomHtmlBlockComponent);
  registry.register(HeroBannerComponent);
  registry.register(RelatedEntriesComponent);
  registry.register(TagDisplayComponent);
}
